// set function parseTime,formatTime to filter
export { parseTime, formatTime } from "@/utils";

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + "s";
}

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), " minute");
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), " hour");
  } else {
    return pluralize(~~(between / 86400), " day");
  }
}

export function secoendToTime(second) {
  var t;
  if (second > -1) {
    var hour = Math.floor(second / 3600);
    var min = Math.floor(second / 60) % 60;
    var sec = second % 60;
    if (hour < 10) {
      t = "0" + hour + ":";
    } else {
      t = hour + ":";
    }

    if (min < 10) {
      t += "0";
    }
    t += min + ":";
    if (sec < 10) {
      t += "0";
    }
    t += sec;
  }
  return t;
}

export function secoendToDate(unixtimestamp) {
  if (unixtimestamp == 0) return 0;
  var unixtimestamp = new Date(unixtimestamp * 1000);
  var year = 1900 + unixtimestamp.getYear();
  var month = "0" + (unixtimestamp.getMonth() + 1);
  var date = "0" + unixtimestamp.getDate();
  var hour = "0" + unixtimestamp.getHours();
  var minute = "0" + unixtimestamp.getMinutes();
  var second = "0" + unixtimestamp.getSeconds();
  return (
    year +
    "-" +
    month.substring(month.length - 2, month.length) +
    "-" +
    date.substring(date.length - 2, date.length) +
    " " +
    hour.substring(hour.length - 2, hour.length) +
    ":" +
    minute.substring(minute.length - 2, minute.length)
  );
  //+ second.substring(second.length-2, second.length);
}

export function secoendToDateOnly(unixtimestamp) {
  var unixtimestamp = new Date(unixtimestamp * 1000);
  var year = 1900 + unixtimestamp.getYear();
  var month = "0" + (unixtimestamp.getMonth() + 1);
  var date = "0" + unixtimestamp.getDate();
  return (
    year +
    "-" +
    month.substring(month.length - 2, month.length) +
    "-" +
    date.substring(date.length - 2, date.length)
  );
}

/* 数字 格式化*/
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: "E" },
    { value: 1e15, symbol: "P" },
    { value: 1e12, symbol: "T" },
    { value: 1e9, symbol: "G" },
    { value: 1e6, symbol: "M" },
    { value: 1e3, symbol: "k" },
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value + 0.1)
          .toFixed(digits)
          .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[i].symbol
      );
    }
  }
  return num.toString();
}

export function toThousandFilter(num) {
  if (!num) return 0
  // 处理字符串或数字类型输入
  let str = typeof num === 'string' ? num : num.toString();
  
  // 处理负数符号
  let sign = '';
  if (str[0] === '-') {
    sign = '-';
    str = str.slice(1);
  }
  
  // 分割整数和小数部分
  const parts = str.split('.');
  let integerPart = parts[0];
  const decimalPart = parts.length > 1 ? `.${parts[1]}` : '';
  
  // 使用正则表达式添加千位分隔符
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  // 合并符号、整数和小数部分
  return sign + integerPart + decimalPart;
}

// 保留六位 不四舍五入
export function numFilter(value) {
  // let transformVal = Number(value).toFixed(6);
  let transformVal = (parseInt(value * 1000000) / 1000000).toFixed(6);
  // let realVal = transformVal.substring(0, transformVal.length);
  return Number(transformVal) || value;
}

// 保留两位小数 不四舍五入
export function numFiltertwo(val) {
  let zhi = (parseInt(val * 100) / 100).toFixed(2);
  return zhi || val;
}
// 邮箱格式校验
// export function emailFilter(value) {
//   return RegExp(
//     /^[a-zA-Z0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/
//   ).test(value);
// }
